<template>
    <div class="ReviewForm text-sm text-left">
        <div v-if="form.successful" class="max-w-3xl mx-auto animated fadeInDown">
            <div v-if="form.rating <= 3" class="alert alert-warning">
                <div class="font-bold">
                    Tak for din udtalelse.
                </div>

                <div class="my-3">
                    Hos betterhype går vi meget op i, at du som brand får et vellykket samarbejde med
                    vores influenter. <br />

                    <span v-if="form.rating <= 2">
                        Vi beklager derfor at din oplevelse kun har været til {{ starsText }} -
                        dette anser vi som en kritisk udtalelse.
                    </span>
                    <span v-else>
                        Når du giver din oplevelse {{ starsText }}, tror vi, at noget kunne
                        forbedres.
                    </span>
                </div>

                <div class="my-3">
                    Teamet bag betterhype vil derfor gennemgå din udtalelse, for at sikre så høj en
                    kvalitet hos vores influenter som muligt.
                </div>

                <div>
                    Venlig hilsen <br />
                    Team betterhype
                </div>
            </div>

            <div v-else class="alert alert-success animated fadeInDown">
                Tak for din udtalelse!
            </div>
        </div>

        <div v-else class="max-w-5xl mx-auto">
            <div class="mb-2">
                Skriv en udtalelse til <b>{{ reviewee.name }}</b> omkring jeres samarbejde:
            </div>

            <FormItem :form="form" field="body" class="mb-2" help-block-label="Udtalelse">
                <TextareaAutosized
                    v-model="form.body"
                    class="form-control"
                    placeholder="Skriv din udtalelse her"
                />
            </FormItem>

            <div class="flex">
                <StaggeredFade>
                    <button
                        v-for="suggestion of availableSuggestions"
                        :key="suggestion.label"
                        type="button"
                        class="bg-purple-300 px-4 py-1 rounded-full mr-2 mb-3 text-purple-800"
                        @click="applySuggestion(suggestion)"
                        v-text="suggestion.label"
                    />
                </StaggeredFade>
            </div>

            <div class="text-center">
                <FormItem :form="form" field="rating" class="mb-4" help-block-label="Bedømmelse">
                    <rating-stars v-model="form.rating"></rating-stars>
                </FormItem>

                <button class="btn btn-primary btn-lg" :disabled="form.busy" @click="submit">
                    Indsend anmeldelse
                </button>
            </div>
        </div>
    </div>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.ReviewForm {
    .RatingStars {
        font-size: 40px;
        letter-spacing: 10px;
    }
}
</style>

<script type="text/babel">
import FormItem from 'dashboard-js/components/utilities/FormItem'
import StaggeredFade from 'dashboard-js/components/utilities/StaggeredFade'
import TextareaAutosized from 'dashboard-js/components/utilities/TextareaAutosized'

export default {
    components: { StaggeredFade, FormItem, TextareaAutosized },

    props: ['reviewee', 'job', 'suggestions'],

    data() {
        return {
            form: new SparkForm({
                body: null,
                rating: null,
            }),
        }
    },

    computed: {
        availableSuggestions() {
            return this.suggestions.filter(suggestion => suggestion.text !== this.form.body)
        },

        starsText() {
            return this.form.rating === 1
                ? this.form.rating + ' stjerne'
                : this.form.rating + ' stjerner'
        },
    },

    methods: {
        applySuggestion(suggestion) {
            const isSuggestion =
                this.suggestions.find(suggestion => this.form.body === suggestion.text) !==
                undefined

            this.form.rating = suggestion.rating
            this.form.body === null || this.form.body.length === 0 || isSuggestion
                ? (this.form.body = suggestion.text)
                : (this.form.body += '\n' + suggestion.text)
        },

        submit() {
            Spark.post(route('api.job.action', [this.job.id, 'review']), this.form).then(
                response => {
                    Bus.$emit('jobUpdated', response.data)

                    this.$emit('submitted', response.data)
                }
            )
        },
    },
}
</script>
